var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#1A496D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3337 33.3335V18.1335C53.3337 13.6531 53.3337 11.4129 52.4617 9.70157C51.6947 8.19628 50.4709 6.97243 48.9656 6.20544C47.2543 5.3335 45.0141 5.3335 40.5337 5.3335H23.467C18.9866 5.3335 16.7464 5.3335 15.0351 6.20544C13.5298 6.97243 12.3059 8.19628 11.5389 9.70157C10.667 11.4129 10.667 13.6531 10.667 18.1335V45.8668C10.667 50.3473 10.667 52.5875 11.5389 54.2988C12.3059 55.8041 13.5298 57.0279 15.0351 57.7949C16.7464 58.6668 18.9866 58.6668 23.467 58.6668H32.0003M37.3337 29.3335H21.3337M26.667 40.0002H21.3337M42.667 18.6668H21.3337M38.667 50.6668L44.0003 56.0002L56.0003 44.0002",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSigned);
export default __webpack_public_path__ + "static/media/status-signed.c9a461f229725c7619a671abf26395f6.svg";
export { ForwardRef as ReactComponent };